import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class ShowcaseProductCollectionListItemDto
*  Строка ленты подборок витрины (без состава товаров)
*/
export class ShowcaseProductCollectionListItemDto extends ActiveModel {

  /**
  * id
  * Идентификатор подборки  */
  @ActiveField(0)
  id: number = 0


/**
  * slug
  * Глобальный ЧПУ; уникален среди неудалённых. Пустой при записи нормализуется из Name.<br>
  */
  @ActiveField('')
  slug: string = ''


/**
  * name
  * Название подборки.<br>
  */
  @ActiveField('')
  name: string = ''


/**
  * description
  * Описание (опционально).<br>
  */
  @ActiveField()
  description?: null | string


  /**
  * order
  * Порядковый номер среди подборок (глобальный).<br>  */
  @ActiveField(0)
  order: number = 0


/**
  * imagesIds
  * Идентификаторы изображений галереи в порядке Domain.Entities.ProductCollections.ProductCollectionImage.Order.<br>Первое — обложка.<br>  */
  @ActiveField({
    setter(model: ShowcaseProductCollectionListItemDto, prop: string, value: Array<string>, receiver?: ShowcaseProductCollectionListItemDto ) {
      return Reflect.set(
        model,
        prop,
        value ? (Array.isArray(value) ? value : [value])
          .map(v => String(v)) : value,
        
        receiver)
    }
  })
  imagesIds: Array<string> = []
}
